import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Card, message, Select, Spin, AutoComplete, Input } from 'antd';
import axios from 'axios';
import { Option } from 'antd/es/mentions';

const IdentificarConsumidor = ({
  isVisible,
  onClose,
  nomeDoCupom,
  documentoDoCupom,
  setConsumidorIdentificado,
  consumidorIdentificado,
  consumidor,
  setConsumidor,
  documentoIntegracao,
  setEmailNota,
  emailNota,
  telefoneEnvio,
  setTelefoneEnvio
}) => {
  const [cpfCnpj, setCpfCnpj] = useState('');
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [logradouro, setLogradouro] = useState('');
  const [numero, setNumero] = useState('');
  const [complemento, setComplemento] = useState('');
  const [cep, setCep] = useState('');
  const [bairro, setBairro] = useState('');
  const [documentoRgIE, setDocumentoRgIE] = useState('');
  const [cidades, setCidades] = useState([]);
  const [estados, setEstados] = useState([]);
  const [paises, setPaises] = useState([]);
  const [estadoSelecionado, setEstadoSelecionado] = useState(
    consumidor?.endereco?.cidade?.cuf,
  );
  const [cidadeSelecionada, setCidadeSelecionada] = useState('');
  const [cpfCnpjMask, setCpfCnpjMask] = useState('cpf');
  const [codigoPais, setCodigoPais] = useState('55');

  const [restauranteId, setRestauranteId] = useState('');

  const [isLoading, setIsLoading] = useState(false);

  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const operador = window.localStorage.getItem('operador');

  const [consumidorJaCadastrado, setConsumirJaCadastrado] = useState(false);

  const [cidadeIBGE, setCidadeIBGE] = useState(null);

  // --- estados e refs para o AutoComplete de Nome ---
  const [optionsAC, setOptionsAC] = useState([]);
  const [loadingSugestoes, setLoadingSugestoes] = useState(false);
  const debounceRef = useRef(null);
  const cancelSourceRef = useRef(null);

  // options (headers) para as chamadas com token
  const authOptions = useMemo(() => ({
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + accessToken,
    },
  }), [accessToken]);

  useEffect(() => {
    if (accessToken && idUser) {
      axios
        .get(
          'https://techspdv-api-d3e739785e34.herokuapp.com/v1/paises',
          authOptions,
        )
        .then(paises => {
          const comboPaises = paises.data._embedded.paises.map(pais => ({
            label: `${pais.codigo} - ${pais.nome}`,
            value: `${pais.codigo}`,
          }));

          setPaises(comboPaises);
        });
    }
  }, [idUser, accessToken, authOptions]);

  useEffect(() => {
    if (accessToken && idUser) {
      axios
        .get(
          `https://techfood-api.herokuapp.com/v1/restaurantes/usuario/${idUser}`,
          authOptions,
        )
        .then(restaurante => {
          setRestauranteId(restaurante.data.id);
          if (documentoIntegracao) {
            setCpfCnpj(documentoIntegracao);
          }
        });

      axios
        .get(
          'https://techspdv-api-d3e739785e34.herokuapp.com/v1/estados',
          authOptions,
        )
        .then(estados => {
          const comboEstados = estados.data._embedded.estados.map(estado => ({
            label: `${estado.nome} - ${estado.uf}`,
            value: estado.cuf,
          }));

          setEstados(comboEstados);
        });
    }
  }, [idUser, accessToken, authOptions]);

  useEffect(() => {
    if (accessToken && idUser && estadoSelecionado) {
      setCidades([]);
      setCidadeSelecionada(null);

      axios
        .get(
          `https://techspdv-api-d3e739785e34.herokuapp.com/v1/cidades/listarPorEstadoCuf/${estadoSelecionado}`,
          authOptions,
        )
        .then(response => {
          const comboCidades = response.data._embedded.cidades.map(cidade => ({
            label: cidade.nome,
            value: cidade.ibge,
            id: cidade.id,
          }));

          setCidades(comboCidades);

          if (cidadeIBGE) {
            const cidadeCorrespondente = comboCidades.find(c => c.value === cidadeIBGE);
            if (cidadeCorrespondente) {
              setCidadeSelecionada(cidadeCorrespondente.value);
            } else {
              console.warn('Cidade não encontrada na lista carregada:', cidadeIBGE);
            }
            setCidadeIBGE(null);
          }

          setIsLoading(false);
        });
    }
  }, [idUser, accessToken, estadoSelecionado, cidadeIBGE, authOptions]);

  useEffect(() => {
    if (consumidor == true) {
    } else {
      if (consumidor) {
        setCpfCnpj(consumidor.documentoCpfCnpj);
        setNome(consumidor.nomeCompleto);
        setEmail(consumidor.email);

        let telefoneLimpo = consumidor.telefone ? consumidor.telefone.replace(/\D/g, '') : '';
        telefoneLimpo = telefoneLimpo.replace(/^55/, '');

        handleTelefoneChange(telefoneLimpo);
        if (consumidor.endereco) {
          setLogradouro(consumidor.endereco.logradouro);
          setNumero(consumidor.endereco.numero);
          setComplemento(consumidor.endereco.complemento);
          setBairro(consumidor.endereco.bairro);
          setDocumentoRgIE(consumidor.documentoRgIE);
          setCep(consumidor.endereco.cep);
          setCidadeSelecionada(consumidor.endereco.cidade.ibge);
          setEstadoSelecionado(consumidor.endereco.cidade.cuf);
        }
      }
    }
  }, [consumidor]);

  const confirmarConsumidor = async () => {
    setConsumidorIdentificado(true);

    const nomeCidade = cidades.find(
      cidade => cidade.value === cidadeSelecionada,
    );

    const estadoNome = estados.find(
      estado => estado.value === estadoSelecionado,
    );

    const uf = estadoNome?.label.split(" - ")[1] || "";

    let consumidorAux = {
      nomeCompleto: nome,
      documentoCpfCnpj: cpfCnpj,
      documentoRgIE: documentoRgIE,
      email: email,
      ie: documentoRgIE,
      telefone: telefone,
      endereco: {
        cep: cep ? cep : "",
        logradouro: logradouro,
        numero: numero,
        complemento: complemento,
        bairro: bairro,
        ufEstado: uf || null,
        cidade: {
          ibge: cidadeSelecionada,
          cuf: estadoSelecionado,
          nome: nomeCidade?.label || null
        },
      },
    };

    documentoDoCupom(cpfCnpj);
    nomeDoCupom(consumidorAux.nomeCompleto);
    setConsumidor(consumidorAux);
    onClose();
    return;
  };

  const salvarConsumidor = () => {
    setIsLoading(true);
    const cidadeSelecionadaAux = cidades.find(
      cidade => cidade.value === cidadeSelecionada,
    );

    const options = authOptions;

    let consumidorForm = {
      ativo: true,
      documentoCpfCnpj: cpfCnpj,
      documentoRgIE: documentoRgIE,
      email: email,
      endereco: {
        bairro: bairro,
        cep: cep,
        cidade: {
          id: cidadeSelecionadaAux.id || '',
        },
        complemento: complemento,
        logradouro: logradouro,
        numero: numero,
      },
      nomeCompleto: nome,
      telefone: limparStringNumerica(`${codigoPais}${telefone}`),
      dataCadastro: consumidor.dataCadastro,
    };

    /*if (consumidor?.id) {
      consumidorForm.id = consumidor?.id;
    }*/

    if (consumidor !== undefined && consumidor !== true) {
      axios
        .put(
          `https://techspdv-api-d3e739785e34.herokuapp.com/v1/clientes/loja/${restauranteId}/${consumidor.id}`,
          consumidorForm,
          options,
        )
        .then(response => {
          setConsumidor(response.data);
          documentoDoCupom(response.data.documentoCpfCnpj);
          nomeDoCupom(response.data.nomeCompleto);
          setConsumidorIdentificado(true);
          setIsLoading(false);
          onClose();
          return;
        })
        .catch(error => {
          setIsLoading(false);
          console.error('Erro:', error);
        });
    } else {
      axios
        .post(
          `https://techspdv-api-d3e739785e34.herokuapp.com/v1/clientes/loja/${restauranteId}`,
          consumidorForm,
          options,
        )
        .then(response => {
          confirmarConsumidor();
        })
        .catch(error => {
          setIsLoading(false);
          console.error('Erro:', error);
        });
    }
  };

  const limparDados = () => {
    setNome('');
    setEmail('');
    setConsumidor(null);
    nomeDoCupom('');
    documentoDoCupom('');
    setCpfCnpj('');
    setTelefone('');
    setDocumentoRgIE('');
    setCep('');
    setBairro('');
    setLogradouro('');
    setNumero('');
    setConsumidorIdentificado(false);
  };

  function validarDocumento(documento) {
    documento = documento.replace(/[^\d]+/g, '');
    if (documento.length === 11) {
      let cpf = documento;
      let add = 0;
      for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
      let rev = 11 - (add % 11);
      if (rev === 10 || rev === 11) rev = 0;
      if (rev !== parseInt(cpf.charAt(9))) return false;

      add = 0;
      for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
      rev = 11 - (add % 11);
      if (rev === 10 || rev === 11) rev = 0;
      if (rev !== parseInt(cpf.charAt(10))) return false;

      return true;
    } else if (documento.length === 14) {
      let cnpj = documento;
      let tamanho = cnpj.length - 2;
      let numeros = cnpj.substring(0, tamanho);
      let digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado !== parseInt(digitos.charAt(0))) return false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado !== parseInt(digitos.charAt(1))) return false;

      return true;
    } else {
      return false;
    }
  }

  const buscarConsumidor = () => {
    if (!cpfCnpj) return;
    if (validarDocumento(cpfCnpj)) {
      const numericText = cpfCnpj.replace(/\D/g, '');
      setIsCnpj(numericText.length > 11);

      if (consumidor) {
        onClose();
        return;
      } else {
        if (accessToken) {
          setIsLoading(true);
          const options = authOptions;

          axios
            .get(
              `https://techspdv-api-d3e739785e34.herokuapp.com/v1/clientes/loja/${restauranteId}/cpfcnpj/${cpfCnpj}`,
              options,
            )
            .then(consumidorResp => {
              if (consumidorResp) {
                if (consumidorResp.data) {
                  setConsumidor(consumidorResp.data);
                  setConsumirJaCadastrado(true);
                  setIsLoading(false);
                } else {
                  setIsLoading(false);
                  setConsumidor(true);
                }
              } else {
                setIsLoading(false);
                setConsumidor(true);
              }

            }).catch(error => {
              console.error('Erro ao buscar consumidor:', error);
              setConsumidor(true);
            })
        }
      }
      return;
    }
  };

  const isTelefoneValido = (numero) => {
    const numeroLimpo = numero.replace(/\D/g, '');
    return (
      (numeroLimpo.length === 10 && /^(\d{2})(\d{4})(\d{4})$/.test(numeroLimpo)) ||
      (numeroLimpo.length === 11 && /^(\d{2})(\d{5})(\d{4})$/.test(numeroLimpo))
    );
  };

  const adicionarEmail = () => {
    if (email) {
      setEmailNota(email);
      onClose();
      return;
    }
    if (telefone) {
      if (isTelefoneValido(telefone)) {
        setTelefoneEnvio(codigoPais + telefone.replace(/\D/g, ''));
        onClose();
        return;
      }
    }
  };

  useEffect(() => {
    if (cep.length === 8) {
      buscarEnderecoPorCep();
    }
  }, [cep]);

  useEffect(() => {
    if (cidadeIBGE && cidades.length > 0) {
      const cidadeEncontrada = cidades.find((c) => c.value === cidadeIBGE);
      if (cidadeEncontrada) {
        setCidadeSelecionada(cidadeEncontrada.value);
      } else {
        console.warn("Cidade não encontrada:", cidadeIBGE);
      }
      setCidadeIBGE(null);
    }
  }, [cidades, cidadeIBGE]);

  const buscarEnderecoPorCep = async () => {
    if (consumidorJaCadastrado) {
      setTimeout(() => {
        setCidadeSelecionada(consumidor.endereco.cidade.ibge);
      }, 1000);
      return;
    }
    setIsLoading(true);
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
      const { data } = response;

      setBairro(data.bairro);
      setLogradouro(data.logradouro);

      if (data.ibge?.length === 7) {
        setEstadoSelecionado(data.ibge.substring(0, 2));
        setCidadeIBGE(data.ibge);
      }
    } catch (error) {
      console.error("Erro ao buscar endereço:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const onChangeCpfCnpj = text => {
    setCpfCnpj(text);
    const numericText = text.replace(/\D/g, '');
    if (numericText.length === 11) {
      setCpfCnpjMask('cpf');
    } else if (numericText.length === 14) {
      setCpfCnpjMask('cnpj');
    }
  };

  const [isCnpj, setIsCnpj] = useState(false);

  const toggleMask = text => {
    const numericText = text.replace(/\D/g, '');
    setIsCnpj(numericText.length > 10);
    setCpfCnpj(numericText);
  };

  const validateEmail = email => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = text => {
    setEmail(text);
  };

  const handleEmailBlur = () => {
    if (email.trim() !== '' && !validateEmail(email)) {
      message('E-mail Inválido', 'Por favor, insira um e-mail válido.');
    }
  };

  const handleTelefoneChange = text => {
    const numeroTelefone = text.replace(/\D/g, '');
    let telefoneFormatado = '';
    if (numeroTelefone.length <= 10) {
      telefoneFormatado = numeroTelefone.replace(
        /^(\d{2})(\d{4})(\d{4})$/,
        '($1) $2-$3',
      );
    } else {
      telefoneFormatado = numeroTelefone.replace(
        /^(\d{2})(\d{5})(\d{4})$/,
        '($1) $2-$3',
      );
    }
    setTelefone(telefoneFormatado);
  };

  function limparStringNumerica(string) {
    return string.replace(/[^0-9\s]/g, '');
  }

  // --------- BUSCA (AutoComplete) ----------
  const fetchSugestoesNome = async (q) => {
    if (!restauranteId) return;
    // cancelar requisição anterior
    if (cancelSourceRef.current) cancelSourceRef.current.cancel('Cancelado por nova busca');
    cancelSourceRef.current = axios.CancelToken.source();

    setLoadingSugestoes(true);
    try {
      const url = `https://techspdv-api-d3e739785e34.herokuapp.com/v1/clientes/loja/${restauranteId}/sugestoes/nome/${encodeURIComponent(q)}`;
      const { data } = await axios.get(url, {
        ...authOptions,
        cancelToken: cancelSourceRef.current.token,
      });

      const opts = (Array.isArray(data) ? data : []).map(item => ({
        value: item.nomeCompleto || '',
        label: item.nomeCompleto || '',
        doc: item.documentoCpfCnpj || '',
      }));
      setOptionsAC(opts);
    } catch (e) {
      if (!axios.isCancel(e)) {
        setOptionsAC([]);
      }
    } finally {
      setLoadingSugestoes(false);
    }
  };

  const handleSearchNome = (q) => {
    setNome(q);
    if (debounceRef.current) clearTimeout(debounceRef.current);

    if (!q || q.trim().length < 3) {
      setOptionsAC([]);
      return;
    }
    debounceRef.current = setTimeout(() => fetchSugestoesNome(q), 1000);
  };

  const handleSelectNome = (value, option) => {
    setNome(value);
    if (option?.doc) {
      // preenche CPF/CNPJ com o documento selecionado
      toggleMask(option.doc);
      documentoDoCupom(option.doc);
    }
  };

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h1>Identificar Consumidor</h1>
      </header>
      {isLoading ? (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 40, width: '100%' }}>
          <Spin
            spinning={isLoading || (!cidadeSelecionada && cep)}
            size="large"
          />
          <span style={{ marginTop: 16, fontSize: 14, color: '#666' }}>{'Carregando...'}</span>
        </div>
      ) : (
        <div>
          {/* Nome com AutoComplete */}
          <label style={styles.label}>Nome</label>
          <AutoComplete
            value={nome}
            onSearch={handleSearchNome}
            onChange={(v) => setNome(v)}
            onSelect={handleSelectNome}
            options={optionsAC}
            style={{ width: '100%' }}
          >
            <Input placeholder="Nome" style={styles.input} loading={loadingSugestoes ? 1 : 0} />
          </AutoComplete>

          <label style={styles.label}>CPF ou CNPJ</label>
          <input
            type="text"
            placeholder="Cpf/Cnpj"
            value={cpfCnpj}
            onChange={(e) => toggleMask(e.target.value)}
            disabled={consumidor}
            style={styles.input}
          />
          <label style={styles.label}>E-mail</label>
          <input
            type="text"
            placeholder="email"
            value={email}
            onChange={(e) => handleEmailChange(e.target.value)}
            onBlur={handleEmailBlur}
            autoComplete="email"
            style={styles.input}
          />

          <label style={styles.label}>Telefone</label>
          <div style={{ display: "flex", gap: "10px", marginBottom: "12px" }}>
            <Select
              value={codigoPais || undefined}
              placeholder="Selecione o país"
              onChange={(valor) => {
                setCodigoPais(valor);
              }}
              style={{
                width: 240,
                borderRadius: 4,
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              }}
              dropdownStyle={{ borderRadius: 4 }}
              size="middle"
            >
              {paises.map((pais) => (
                <Option key={pais.value} value={pais.value}>
                  {pais.label}
                </Option>
              ))}
            </Select>
            <input
              type="tel"
              placeholder="Telefone"
              value={telefone}
              onChange={(e) => handleTelefoneChange(e.target.value)}
              style={styles.input}
            />
          </div>

          {consumidor && (
            <>
              <label style={styles.label}>RG ou IE</label>
              <input
                type="text"
                placeholder="Rg/Ie"
                value={documentoRgIE}
                onChange={(e) => setDocumentoRgIE(e.target.value)}
                style={styles.input}
              />
              <label style={styles.label}>Estado</label>
              <Select
                value={estadoSelecionado || undefined}
                placeholder="Selecione o estado"
                onChange={(valor) => {
                  setEstadoSelecionado(valor);
                  setCidadeSelecionada('');
                }}
                style={{
                  width: 240,
                  borderRadius: 4,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                }}
                dropdownStyle={{
                  borderRadius: 4,
                }}
                size="middle"
              >
                {estados.map((estado) => (
                  <Option key={estado.value} value={estado.value}>
                    {estado.label}
                  </Option>
                ))}
              </Select>
              <label style={styles.label}>Cep</label>
              <input
                type="text"
                placeholder="Cep"
                value={cep}
                onChange={(e) => setCep(e.target.value)}
                maxLength={8}
                style={styles.input}
              />

              <label style={styles.label}>Cidade</label>
              <Select
                value={cidadeSelecionada || undefined}
                placeholder={
                  estadoSelecionado
                    ? 'Selecione a cidade'
                    : 'Selecione o estado primeiro'
                }
                onChange={(valor) => {
                  setCidadeSelecionada(valor);
                }}
                disabled={!estadoSelecionado}
                style={{
                  width: 240,
                  borderRadius: 4,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                }}
                dropdownStyle={{ borderRadius: 4 }}
                size="middle"
              >
                {cidades.map((cidade) => (
                  <Option key={cidade.value} value={cidade.value}>
                    {cidade.label}
                  </Option>
                ))}
              </Select>

              <label style={styles.label}>Bairro</label>
              <input
                type="text"
                placeholder="Bairro"
                value={bairro}
                onChange={(e) => setBairro(e.target.value)}
                style={styles.input}
              />

              <label style={styles.label}>Logradouro</label>
              <input
                type="text"
                placeholder="Logradouro"
                value={logradouro}
                onChange={(e) => setLogradouro(e.target.value)}
                style={styles.input}
              />

              <label style={styles.label}>Número</label>
              <input
                type="text"
                placeholder="Numero"
                value={numero}
                onChange={(e) => setNumero(e.target.value)}
                style={styles.input}
              />

              <label style={styles.label}>Complemento</label>
              <input
                type="text"
                placeholder="Complemento"
                value={complemento}
                onChange={(e) => setComplemento(e.target.value)}
                style={styles.input}
              />
            </>
          )}
          <div style={styles.actions}>
            {consumidor ? (
              <>
                <button onClick={confirmarConsumidor}
                  style={{
                    ...styles.button,
                    cursor: !cidadeSelecionada && cep ? "not-allowed" : "pointer",
                    opacity: !cidadeSelecionada && cep ? 0.6 : 1,
                  }}
                  disabled={!cidadeSelecionada && cep}>
                  Confirmar CPF na Venda
                </button>
                <button onClick={limparDados} style={{ ...styles.button, ...styles.buttonRed }}>
                  Limpar Dados
                </button>
                <button onClick={salvarConsumidor} style={{
                  ...styles.button,
                  cursor: !cidadeSelecionada || !cpfCnpj || !nome || !estadoSelecionado || !cep || !cidadeSelecionada || !bairro || !logradouro || !numero ? "not-allowed" : "pointer",
                  opacity: !cidadeSelecionada || !cpfCnpj || !nome || !estadoSelecionado || !cep || !cidadeSelecionada || !bairro || !logradouro || !numero ? 0.6 : 1,
                }}
                  disabled={!cidadeSelecionada || !cpfCnpj || !nome || !estadoSelecionado || !cep || !cidadeSelecionada || !bairro || !logradouro || !numero}>
                  Cadastrar Cliente
                </button>

                <button
                  onClick={() => {
                    onClose();
                    if (!consumidorIdentificado) {
                      setConsumidor(null);
                      nomeDoCupom("");
                      documentoDoCupom("");
                    }
                  }}
                  style={{ ...styles.button, ...styles.buttonRed }}
                >
                  Voltar
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={() => {
                    onClose();
                    if (!consumidorIdentificado) {
                      setConsumidor(null);
                      nomeDoCupom("");
                      documentoDoCupom("");
                    }
                  }}
                  style={{ ...styles.button, ...styles.buttonRed }}
                >
                  Fechar
                </button>
                <button
                  onClick={cpfCnpj ? buscarConsumidor : adicionarEmail}
                  disabled={isLoading}
                  style={{
                    ...styles.button,
                    ...(isLoading && styles.buttonDisabled),
                  }}
                >
                  Confirmar
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: "16px",
    maxWidth: "600px",
    margin: "0 auto",
    backgroundColor: "#f9f9f9",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  headerButton: {
    padding: "8px 12px",
    backgroundColor: "#ff5c5c",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
  },
  label: {
    display: "block",
    marginBottom: "6px",
    fontWeight: "bold",
    fontSize: "14px",
    color: "#555",
  },
  input: {
    width: "100%",
    padding: "8px",
    marginBottom: "12px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    fontSize: "14px",
    boxSizing: "border-box",
  },
  actions: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    gap: "10px",
  },
  button: {
    flex: "1 1 calc(50% - 10px)",
    minWidth: "150px",
    padding: "12px",
    borderRadius: "6px",
    border: "1px solid #000000",
    backgroundColor: "#000000",
    fontSize: "14px",
    fontWeight: "bold",
    color: "#ffffff",
  },
  buttonRed: {
    backgroundColor: "#ff5c5c",
    color: "#fff",
    border: "none",
  },
  buttonDisabled: {
    backgroundColor: "#ccc",
    cursor: "not-allowed",
  }
};

export default IdentificarConsumidor;
